<template>
  <b-sidebar
    id="add-new-user-sidebar"
    :visible="isAddNewUserSidebarActive"
    bg-variant="white"
    sidebar-class="sidebar-lg"
    shadow
    backdrop
    no-header
    right
    @hidden="resetForm"
    @change="(val) => $emit('update:is-add-new-user-sidebar-active', val)"
  >
    <template #default="{ hide }">
      <!-- Header -->
      <div class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1">
        <h5 class="mb-0">
          
          {{ saveType=='influencer' ? 'Yeni Influencer Ekle' : 'Yeni Admin Ekle' }}
        </h5>

        <feather-icon
          class="ml-1 cursor-pointer"
          icon="XIcon"
          size="16"
          @click="hide"
        />

      </div>

      <!-- BODY -->
      <validation-observer
        #default="{ handleSubmit }"
        ref="refFormObserver"
      >
        <!-- Form -->
        <b-form
          class="p-2"
          @submit.prevent="handleSubmit(onSubmit)"
          @reset.prevent="resetForm"
        >
        
          <!-- Username -->
          <validation-provider
            #default="validationContext"
            name="Kullanıcı adı"
            rules="required"
            v-if="saveType=='influencer'"
          >
          
            <b-form-group
              label="Kullanıcı adı"
              label-for="username"
            >
              <b-input-group
                prepend="https://www.instagram.com/"
              >
                <b-form-input
                  id="username"
                  v-model="user.username"
                  :state="getValidationState(validationContext)"
                  trim
                />
                <b-form-invalid-feedback>
                  {{ validationContext.errors[0] }}
                </b-form-invalid-feedback>
              </b-input-group>
            </b-form-group>
          </validation-provider>

          <!-- Full Name -->
          <validation-provider
            #default="validationContext"
            name="Ad Soyad"
            rules="required"
          >
            <b-form-group
              label="Ad Soyad"
              label-for="name_surname"
            >
              <b-form-input
                id="full-name_surname"
                v-model="user.name_surname"
                autofocus
                :state="getValidationState(validationContext)"
                trim
              />

              <b-form-invalid-feedback>
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>
          

          <b-form-group>
            <b-form-checkbox v-model="user.no_email" v-if="saveType=='influencer'">
              Mail adresi olmayacak
            </b-form-checkbox>
          </b-form-group>

          
          <!-- Email -->
          <validation-provider
            #default="validationContext"
            name="Email"
            rules="required|email"
            v-if="!user.no_email || saveType=='admin'"
          >
            <b-form-group
              label="Email"
              label-for="email"
            >
              <b-form-input
                id="email"
                v-model="user.email"
                :state="getValidationState(validationContext)"
                trim
              />

              <b-form-invalid-feedback>
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>

           <b-alert
            show
            variant="danger"
          >
          <div class="alert-body" v-if="user.no_email && saveType=='influencer'">
            <feather-icon
              icon="InfoIcon"
              class="mr-50 mt-25"
            />
            Email girilmediği durumda fenoman sisteme giriş yapamayacaktır.
          </div>
          </b-alert>
          
          

         <template>
            <validation-provider
              #default="validationContext"
              name="Telefon"
            >
            <b-form-group>
              <b-input-group label="Telefon" label-for="phone">
                <!-- Aranabilir ülke seçici -->
                <b-input-group-prepend style="width: 100px;">
                  <v-select
                    v-model="selectedCountry"
                    :options="countryOptions"
                    class="custom-vue-select w-100" 
                    label="label"
                    :clearable="false"
                    placeholder="Ülke ara..."
                  >
                    <template #option="option">
                      +{{ option.dialCode }} — {{ option.name }}
                    </template>
                    <template #selected-option="option">
                      +{{ option.dialCode }}
                    </template>
                  </v-select>
                </b-input-group-prepend>

                <!-- Ülkeye göre mask'lanan telefon input'u -->
                <cleave
                  id="phone"
                  :key="selectedCountry.iso2"
                  v-model="user.phone"
                  class="form-control"
                  :raw="false"
                  :options="cleavePhoneOptions"
                  :placeholder="placeholderMask"
                />

                <b-form-invalid-feedback>
                  {{ validationContext.errors[0] }}
                </b-form-invalid-feedback>
              </b-input-group>
              </b-form-group>
            </validation-provider>
          </template>

          <!-- Hakediş Süresi -->
          <validation-provider
            #default="validationContext"
            v-if="saveType=='influencer'"
            name="Hakediş Süresi"
            rules="required|regex:^([0-9]+)$"
          >
            <b-form-group
              label="Hakediş Süresi"
              label-for="vesting_period"
            >
            <b-input-group
                append="Gün"
              >
              <b-form-input
                type="number"
                id="phone"
                v-model="user.vesting_period"
                :state="getValidationState(validationContext)"
                trim
              />
              <b-form-invalid-feedback>
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-input-group>
            </b-form-group>
          </validation-provider>

          <b-row 
          v-if="saveType=='influencer'">
            
            <!-- Field: Tax 1 -->
            <b-col cols="6">
              <validation-provider
                #default="validationContext"
                name="Link İçi Oran"
                rules="required|regex:^([0-9]+)$"
              >
                <b-form-group
                  label="Link İçi Oran"
                  label-for="link_ici_odeme_orani"
                >
                  <b-input-group
                    prepend="%"
                  >
                    <b-form-input
                      type="number"
                      id="link_ici_odeme_orani"
                      v-model="user.link_ici_odeme_orani"
                      :state="getValidationState(validationContext)"
                      trim
                    />
                    <b-form-invalid-feedback>
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </b-input-group>
                </b-form-group>
              </validation-provider>
            </b-col>

            <!-- Field: Tax 2 -->
            <b-col cols="6">
              <validation-provider
                #default="validationContext"
                name="Dış Link Oran"
                rules="required|regex:^([0-9]+)$"
              >
                <b-form-group
                  label="Dış Link Oran"
                  label-for="link_ici_odeme_orani"
                >
                  <b-input-group
                    prepend="%"
                  >
                    <b-form-input
                      type="number"
                      id="link_disi_odeme_orani"
                      v-model="user.link_disi_odeme_orani"
                      :state="getValidationState(validationContext)"
                      trim
                    />
                  <b-form-invalid-feedback>
                    {{ validationContext.errors[0] }}
                  </b-form-invalid-feedback>
                  </b-input-group>
                </b-form-group>
              </validation-provider>
            </b-col>

           

          </b-row>
          
          <b-row 
          v-if="saveType=='influencer'">
           <b-col cols="12">
              <!-- Paylaşım Ödeme Tutarı -->
              <validation-provider
                #default="validationContext"
                name="Paylaşım Başı Fiyat (Opsiyonel)"
                rules="regex:^([0-9]+)$"
              >
                <b-form-group
                  label="Paylaşım Başı Fiyat (Opsiyonel)"
                  label-for="payment_amount"
                >
                  <b-input-group
                        append="₺"
                      >
                  <b-form-input
                    id="payment_amount"
                    v-model="user.payment_amount"
                    placeholder="1000"
                    :state="getValidationState(validationContext)"
                    trim
                  />
                  </b-input-group>


                  <b-form-invalid-feedback>
                    {{ validationContext.errors[0] }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </validation-provider>
            </b-col>
          </b-row>

          <!-- Form Actions -->
          <div class="d-flex mt-2">
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="primary"
              class="mr-2"
              type="submit"
              :disabled="addLoading"
            >
              <b-spinner small v-if="addLoading" class="mr-1" />
              {{ addLoading ? 'İşlem Yapılıyor...' : 'Ekle' }}
            </b-button>

            <b-button
              v-ripple.400="'rgba(186, 191, 199, 0.15)'"
              type="button"
              variant="outline-secondary"
              @click="hide"
              :disabled="addLoading"
            >
              Vazgeç
            </b-button>
          </div>

        </b-form>
      </validation-observer>
    </template>
  </b-sidebar>
</template>

<script>
import {
  BSidebar, BForm, BRow, BCol, BInputGroup, BFormGroup,
  BInputGroupPrepend, BFormInput, BFormInvalidFeedback, BButton, BSpinner,
  BFormCheckbox,
  BAlert
} from 'bootstrap-vue'
import Cleave from 'vue-cleave-component'
import allCountries from 'country-telephone-data';
import 'cleave.js/dist/addons/cleave-phone.i18n';
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { ref,computed, watch  } from '@vue/composition-api'
import { required, email } from '@validations'
import formValidation from '@core/comp-functions/forms/form-validation'
// Notification
import{ BFormSelect } from 'bootstrap-vue'
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import Ripple from 'vue-ripple-directive'
import vSelect from 'vue-select'
import axiosIns from '@/axios'
import store from '@/store'

export default {
  components: {
    BRow,
    BCol,
    BSidebar,
    BForm,
    BFormGroup,
    BInputGroup,
    BFormInput,
    BFormInvalidFeedback,
    BButton,
    BSpinner,
    vSelect,
    Cleave,
    BFormCheckbox,
    BAlert,
    BInputGroupPrepend,
    BFormSelect,

    // Form Validation
    ValidationProvider,
    ValidationObserver,
  },
  directives: {
    Ripple,
  },
  model: {
    prop: 'isAddNewUserSidebarActive',
    event: 'update:is-add-new-user-sidebar-active',
  },
  props: {
    isAddNewUserSidebarActive: {
      type: Boolean,
      required: true,
    },
    saveType: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      required,
      email,
      clevePhone: {
        phone: true,
        phoneRegionCode: 'TR',
      },
    }
  },
  setup(props, { emit }) {

    const toast = useToast()

    const addLoading = ref(false)

    const customerInfo = store.state.user.customerInfo

    const blankUser = {
      username: null,
      name_surname: '',
      email: '',
      phone: '',
      customer_id:customerInfo.id,
      link_ici_odeme_orani:store.state.appConfig.defaultVat.icLink,
      link_disi_odeme_orani:store.state.appConfig.defaultVat.disLink,
      vesting_period:store.state.appConfig.vestingPeriod,
      no_email: true,
      payment_amount: null,
    }

    const user = ref(JSON.parse(JSON.stringify(blankUser)))
    const resetuser = () => {
      user.value = JSON.parse(JSON.stringify(blankUser))
    }

    const selectedCountry = ref({
      name: 'Turkey',
      iso2: 'tr',
      dialCode: '90',
      example: '507 091 19 69',
    });

    const countryOptions = computed(() =>
      allCountries.allCountries.map((c) => ({
        name: c.name,
        iso2: c.iso2,
        dialCode: c.dialCode,
        label: `${c.name} (+${c.dialCode})`,
      }))
    );

    const placeholderMask = computed(() => {
      const country = allCountries.allCountries.find(
        (c) => c.iso2 === selectedCountry.value.iso2
      );

      // format alanı örn: ".. ... .. .." şeklinde geliyor, noktaları alt çizgiye çeviriyoruz
      if (country && country.format) {
        return country.format.replace(/\./g, '_');
      }

      // format bilgisi olmayan ülkeler için genel bir fallback
      return '___ ___ __ __';
    });

    
    const cleavePhoneOptions = computed(() => {
      const country = allCountries.allCountries.find(
        c => c.iso2 === selectedCountry.value.iso2
      );

      if (!country || !country.format) {
        return {
          numericOnly: true
        };
      }

      let format = country.format;

      // +.. ülke kodunu kaldır
      format = format.replace(/^\+\.\./, '');

      // Noktalardan oluşan blokları bul
      const blocks = [];
      const delimiters = [];

      const regex = /(\.+)|([^\d.]+)/g;
      let match;

      while ((match = regex.exec(format)) !== null) {
        if (match[1]) {
          blocks.push(match[1].length);
        } else if (match[2]) {
          delimiters.push(match[2]);
        }
      }

      return {
        numericOnly: true,
        blocks,
        delimiter: delimiters[0] || ''
      };
    });

    const fullPhoneNumber = computed(
      () => `+${selectedCountry.value.dialCode}${user.phone.replace(/\s/g, '')}`
    );


    const onSubmit = () => {

      if (addLoading.value) return; // Zaten loading durumundaysa tekrar çalıştırma
  
      addLoading.value = true; // Butona tıklanınca loading başlasın
      user.value.user_type=props.saveType
      axiosIns.post(`/user`, user.value)
        .then((response) => {
          if(response.data.success){
            toast({
              component: ToastificationContent,
              position: 'bottom-right',
              props: {
                icon: 'CheckCircleIcon',
                variant: 'success', // Başarısızlık durumunda 'error' olabilir
                title: response.data.message, // response.data.error kullanarak doğru veriyi kontrol edin
              },
            });
            emit('refetch-data')
            emit('update:is-add-new-user-sidebar-active', false)
          }else{
            toast({
              component: ToastificationContent,
              position: 'bottom-right',
              props: {
                icon: 'MailIcon',
                variant: 'warning', // Başarısızlık durumunda 'error' olabilir
                title: response.data.error, // response.data.error kullanarak doğru veriyi kontrol edin
              },
            });
          }
        }).catch((error) => {
          // Hata işleme
          toast({
            component: ToastificationContent,
            position: 'bottom-right',
            props: {
              icon: 'InfoIcon',
              variant: 'warning',
              title: 'Bir hata oluştu: ' + error.message,
            },
          });
        })
        .finally(() => {
          addLoading.value = false; // İşlem tamamlanınca tekrar butonu aktif hale getir
        });
    }

    watch(selectedCountry, (newCountry) => {
      // Eğer kullanıcı telefon numarasını zaten girmişse, ülke değiştiğinde telefon numarasını temizle
      if (user.value.phone) {
        user.value.phone = '';
      }
    });

    const {
      refFormObserver,
      getValidationState,
      resetForm,
    } = formValidation(resetuser)

    return {
      user,
      onSubmit,      
      addLoading,

      refFormObserver,
      getValidationState,
      resetForm,

      countryOptions,
      placeholderMask,
      selectedCountry,
      cleavePhoneOptions,
      fullPhoneNumber,
    }
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';

#add-new-user-sidebar {
  .vs__dropdown-menu {
    max-height: 200px !important;
  }
}
</style>
